import { render, staticRenderFns } from "./CostAmout.vue?vue&type=template&id=7ffd3400&scoped=true&"
import script from "./CostAmout.vue?vue&type=script&lang=js&"
export * from "./CostAmout.vue?vue&type=script&lang=js&"
import style0 from "./CostAmout.vue?vue&type=style&index=0&id=7ffd3400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd3400",
  null
  
)

export default component.exports